import React from 'react';
import {
  useGetAccountInfo,
  DappUI,
  transactionServices,
  refreshAccount,
  useGetNetworkConfig
} from '@elrondnetwork/dapp-core';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { getContractData, getContractDataBoolean } from 'apiRequests';
import { contractAddress } from 'config';
import { StateType } from './types';
import Countdown, { CountdownRenderProps, zeroPad } from 'react-countdown';
const intervalLoaded = false;

const ContractDatas = ({
  price,
  inWhitelist,
  inMint
}: {
  price: string;
  inWhitelist: undefined | string;
  inMint: undefined | string;
}) => {
  let pageTitle = 'Private 1 sale is Soldout';
  if (inMint === '1') {
    if (inWhitelist === '1') {
      pageTitle = 'Pre sale is live';
    } else {
      pageTitle = 'Private 1 sale is Soldout';
    }
  }

  const preSaleDate = new Date('April 07 2022 20:00:00 GMT+0100');

  // eslint-disable
  const renderer = (props: CountdownRenderProps) => {
    // eslint-disable
    if (!props.completed) {
      // Render a countdown
      return (
        <div>
          <span className='countdown-bg text-white py-3 px-2 font-weight-bold display-3 '>
            {zeroPad(props.days)}
          </span>
          <span className='countdown-bg text-white py-3 px-2 ml-5 font-weight-bold display-3 '>
            {zeroPad(props.hours)}
          </span>
          <span className='countdown-bg text-white py-3 px-2 ml-5 font-weight-bold display-3 '>
            {zeroPad(props.minutes)}
          </span>
          <span className='countdown-bg text-white py-3 px-2 ml-5 font-weight-bold display-3 '>
            {zeroPad(props.seconds)}
          </span>
        </div>
      );
    } else {
      return <div></div>;
    }
  };

  return price != '' ? (
    <div className='text-center'>
      <div className='text-white font-weight-bold h1'>{pageTitle}</div>
      <div className='text-white h4'>
        Mint Price : {(parseInt(price) / 1000000000000000000).toString()} eGLD
      </div>
    </div>
  ) : (
    <div className='my-5'>
      <DappUI.PageState
        icon={faSpinner}
        className='text-muted fa-3x'
        title='Loading contract data'
      />
    </div>
  );
};

export default ContractDatas;
